import 'cross-fetch/polyfill';
import { RESPONSE_404, STATIC_FILE_FORWARD_HEADERS } from '../../constants';

const getHandler = (fileQuery, getVariables) => async props => {
  const { res, apolloClient } = props;
  const variables = getVariables ? getVariables(props) : {};
  const {
    data: { files = [] }
  } = await apolloClient.query({ query: fileQuery, variables });
  const [{ mimetype, url } = {}] = files;
  if (!url) {
    res.writeHead(404);
    res.write(RESPONSE_404);
    res.end();
    return;
  }

  const fileResponse = await fetch(url);

  setHeadersFromResponse(fileResponse.headers, res);
  res.writeHead(200, { 'Content-Type': mimetype });
  res.write(await fileResponse.text());
  res.end();
};

function setHeadersFromResponse(headers, res) {
  STATIC_FILE_FORWARD_HEADERS.forEach(headerKey => {
    const headerValue = headers.get(headerKey);
    if (!headerValue) return;

    res.setHeader(headerKey, headerValue);
  });
}

export default getHandler;
